export enum InfrastructureProjectType {
  EDUCATION = 'EDUCATION',
  HEALTH = 'HEALTH',
  CULTURE_SPORT = 'CULTURE_SPORT',
  // GAS_SUPPLY = 'GAS_SUPPLY',
  INTERNET_COMMUNICATION = 'INTERNET_COMMUNICATION',
  WATER_SUPPLY = 'WATER_SUPPLY',
  ACCESS_ROAD = 'ACCESS_ROAD',
  VILLAGE_ROAD = 'VILLAGE_ROAD',
  LIGHTING = 'LIGHTING',
  SNP_AGRICULTURE_PRODUCERS = 'SNP_AGRICULTURE_PRODUCERS',
  SNP_IMPROVEMENT = 'SNP_IMPROVEMENT',
  SNP_INVESTMENT = 'SNP_INVESTMENT',
  DISTRICT_IMPROVEMENT = 'DISTRICT_IMPROVEMENT',
}


export interface IInfrastructureProjectObject {
  images: {
    IMAGE_AFTER: { id: number; date: string }[];
    IMAGE_CURRENT: { id: number; date: string }[];
  };
  infrastructureEntity: IInfrastructureProject;
  streets: IStreet[];
}

export interface IInfrastructureProject {
  id: number,
  kato: number,
  nameKz: string | null,
  nameRu: string | null,
  nameEn: string | null,
  isSchool: string | null,
  constructionYear: number | null,
  factInfo: string | null,
  factCondition: string | null,
  power: string | null,
  qualityRu: string | null,
  qualityKz: string | null,
  requirements: string | null,
  requirementsRu: string | null,
  requirementsKz: string | null,
  lastMajorRenovation: string | null,
  documentationStatus: string | null,
  requiredFund: Record<string, {
    labelRu: string,
    labelKz: string,
    value: string
  }> | null,
  repairRequired: string | null,
  requiredFundSourceRu: string | null,
  requiredFundSourceKz: string | null,
  requiredFundAmount: number | null,
  workStart: string | null,
  workEnd: string | null,
  sportSections: Record<string, string> | null,
  additionalFields: Record<string, any> | null,
  files: IFile[] | null
  factLocationKz: string | null
  factLocationRu: string | null,
  communicationProvider: {
    name: string | null,
  } | null,
  otherProviders: string | null,
  subscriberNumber: string | null,
  roadLength: string | number | null,
  lightenedStreetLength: string | number | null,
  lightenedStreetNumber: string | number | null,
  lighteningCover: string | number | null,
  totalStreetLength: string | number | null,
  totalStreetNumber: string | number | null,
  streetList: IStreet[],
  illuminated: string | number | null,
  illuminatedStreetLength: string | number | null,
  realizationYear: number | string | null,
  projectPowerRu: string | null,
  projectPowerKz: string | null,
  investmentFund: string | number | null,
  workPlaceNumber: string | number | null,
  shortDescriptionRu: string | null,
  shortDescriptionKz: string | null,
  expectedEffectRu: string | null,
  expectedEffectKz: string | null,
}

export interface IStreet {
  id: number,
  nameKz: string,
  nameRu: string,
  totalStreetLength: string | number | null,
  factCondition: string | null,
  documentationStatus: string | null,
  repairRequired: string | null,
  requiredFundSourceRu: string | null,
  requiredFundSourceKz: string | null,
  requiredFundAmount: number | null,
  requiredFund: Record<string, {
    labelRu: string,
    labelKz: string,
    value: string
  }> | null,
  workStart: string | null,
  workEnd: string | null,
  files: IFile[]
}

export interface IFile {
  date: string;
  fileType: "IMAGE_CURRENT" | "IMAGE_AFTER";
  id: number;
}
